'use strict';

global.tarteaucitron = require('tarteaucitronjs/tarteaucitron.js');

tarteaucitron.init({
  'privacyUrl': '', /* Privacy policy url */

  'hashtag':    '#tarteaucitron', /* Open the panel with this hashtag */
  'cookieName': 'anfrfr_accept', /* Cookie name */

  'orientation':    'bottom', /* Banner position (top - bottom) */
  'showAlertSmall': false, /* Show the small banner on bottom right */
  'cookieslist':    true, /* Show the cookie list */

  'adblocker':               false, /* Show a Warning if an adblocker is detected */
  'AcceptAllCta':            true, /* Show the accept all button when highPrivacy on */
  'highPrivacy':             false, /* Disable auto consent */
  'handleBrowserDNTRequest': false, /* If Do Not Track == 1, disallow all */

  'removeCredit':   true, /* Remove credit link */
  'moreInfoLink':   false, /* Show more info link */
  'useExternalCss': true, /* If false, the tarteaucitron.css file will be loaded */

  //"cookieDomain": '', /* Shared cookie for subdomain website */

  'readmoreLink':
    typeof cookie_readmoreLink !== 'undefined'
      ? cookie_readmoreLink
      : '' /* Change the default readmore link pointing to opt-out.ferank.eu */
});
